import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { IResponseData } from '@core/shared/interfaces/response-data.interface';

export type FeatureFlags = Record<string, boolean>;

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagApiService extends BaseApiService {
  private path = '/api/v1/feature-flags';

  async getAll(): Promise<IResponseData<FeatureFlags>> {
    return this.get(this.path);
  }
}
